module.exports = __webpack_public_path__ + "static/img/theScript.3ccdbd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/theScript.png
// module id = 4Jqr
// module chunks = 1